<template>
  <div class="is-newspaper-content">
    <div
      class="box is-clickable"
      v-for="(newspaper, index) in newspapers"
      :key="index"
      @click="showNewspaper(newspaper)"
    >
      <div class="columns is-vcentered is-newspaper">
        <div class="column">
          <img
            :src="getPicture(newspaper)"
            :alt="newspaper.title"
            class="newspaper-picture"
          />
        </div>
        <div class="column">
          <h1 class="title is-3">{{ newspaper.title }}</h1>
          <p v-html="newspaper.description"></p>
        </div>
      </div>
    </div>
    <waiting-overlay v-if="toWait" />
  </div>
</template>

<script>
// @ is an alias to /src
import WaitingOverlay from "@/components/generic/WaitingOverlay";

export default {
  name: "PublicationsView",
  data: () => ({
    newspapers: [],
    imageBase: "/visualizador/pictures/",
    toWait: false,
  }),
  methods: {
    async getNewspapers() {
      const opts = {
        method: "GET",
        headers: { "Content-Type": 'application/json; charset=UTF-8"' },
      };
      const res = await fetch(
        "/visualizador/public/index.php/FileInfo/getNewspapers",
        opts
      ).then((res) => res.json());
      this.newspapers = res;
    },
    getPicture(newspaper) {
      return this.imageBase + newspaper.directory + ".png";
    },
    showNewspaper(newspaper) {
      this.$router.push("/revista/" + newspaper.directory);
    },
  },
  async created() {
    this.toWait = true;
    await this.getNewspapers();
    this.toWait = false;
  },
  components: {
    WaitingOverlay,
  },
};
</script>

<style scoped>
.newspaper-picture {
  height: 100px;
}

.is-clickable {
  cursor: pointer;
}

.is-newspaper {
  height: 10em;
}

.is-newspaper-content {
  margin-top: 2em;
}
</style>
